import tfaLogoSrc from '../assets/tfa-logo.png'

/**
 * TFA brand logo — uses the real PNG asset (DNA double-helix on transparent bg).
 * For tinting (e.g. white watermark on dark card), use the `tint` prop which
 * applies a CSS `filter` chain. Default is the original brand-blue.
 */

type Tint = 'original' | 'white' | 'dark'

interface Props {
  size?: number | string
  /** Visual recoloring via CSS filter. `original` keeps brand blue. */
  tint?: Tint
  /** 0..1 alpha multiplier — for watermark renders. */
  opacity?: number
  style?: React.CSSProperties
  alt?: string
}

const TINT_FILTER: Record<Tint, string | undefined> = {
  original: undefined,
  white: 'brightness(0) invert(1)',
  dark: 'brightness(0)',
}

export function TfaLogo({ size = 24, tint = 'original', opacity = 1, style, alt = '' }: Props) {
  return (
    <img
      src={tfaLogoSrc}
      alt={alt}
      width={typeof size === 'number' ? size : undefined}
      height={typeof size === 'number' ? size : undefined}
      draggable={false}
      style={{
        display: 'block',
        width: size,
        height: size,
        objectFit: 'contain',
        opacity,
        filter: TINT_FILTER[tint],
        userSelect: 'none',
        pointerEvents: 'none',
        ...style,
      }}
    />
  )
}
